import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import PortfolioModal from '../components/PortfolioModal';
import './Portfolio.css';
import './Home.css';

const Portfolio = () => {
  useScrollAnimation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      id: 1,
      category: 'Site Vitrine',
      image: '/NC&I Immobilier.png',
      title: 'NC&I Immobilier',
      description: 'Développement Web',
      link: 'https://www.niamianconstruction-industrie.com/',
      modalData: {
        img: '/NC&I Immobilier.png',
        title: 'NC&I Immobilier',
        challenge: '',
        solution: '',
        link: 'https://www.niamianconstruction-industrie.com/'
      }
    },
    {
      id: 2,
      category: 'Site Vitrine',
      image: '/Ecomarket.png',
      title: 'Ecomarket',
      description: 'Développement Web',
      link: 'https://Ecomarket-ci.com',
      modalData: {
        img: '/Ecomarket.png',
        title: 'Ecomarket',
        challenge: '',
        solution: '',
        link: 'https://Ecomarket-ci.com'
      }
    },
    {
      id: 3,
      category: 'Application Web',
      image: '/Xlotto.png',
      title: 'Xlotto',
      description: 'Développement Web',
      link: '#',
      modalData: {
        img: '/Xlotto.png',
        title: 'Xlotto',
        challenge: '',
        solution: '',
        link: '#'
      }
    },
    {
      id: 4,
      category: 'Design UX/UI',
      image: '/sig....png',
      title: 'SIG...',
      description: 'Design & Développement',
      link: 'https://cybernexservices.com',
      modalData: {
        img: '/sig....png',
        title: 'Design UX/UI',
        challenge: 'Refonte complète de l\'expérience utilisateur d\'une plateforme existante.',
        solution: '<p>Analyse des parcours utilisateurs, création de wireframes et de maquettes haute-fidélité.</p>',
        link: 'cybernexservices.com'
      }
    },
    {
      id: 5,
      category: 'Site Vitrine',
      image: '/medine.png',
      title: 'Medine Ticket',
      description: 'Développement Web et mobile',
      link: 'https://medine.site',
      modalData: {
        img: '/medine.png',
        title: 'Site Vitrine pour Medine Ticket',
        challenge: 'Le client avait besoin d\'une présence en ligne professionnelle pour présenter ses services.',
        solution: '<p>Nous avons conçu un site vitrine épuré et rapide, mettant en avant les compétences du client.</p>',
        link: 'https://medine.site'
      }
    },
    {
      id: 6,
      category: 'Application Web',
      image: '/afriquequiose.png',
      title: 'Afrique qui Ose',
      description: 'Développement Web & Design',
      link: 'http://afriquequiose.com',
      modalData: {
        img: '/afriquequiose.png',
        title: 'App web pour Afrique qui ose',
        challenge: 'Le client souhaitait moderniser son image et augmenter sa visibilité.',
        solution: '<ul><li>Création d\'une identité visuelle moderne.</li><li>Optimisation de l\'expérience utilisateur pour mobile.</li></ul>',
        link: 'http://afriquequiose.com'
      }
    },
    {
      id: 7,
      category: 'Site Vitrine',
      image: '/edencorporate.png',
      title: 'Eden Corporate',
      description: 'Développement web',
      link: 'https://www.edencorporate.com/',
      modalData: {
        img: '/edencorporate.png',
        title: 'Application web pour Eden Corporate',
        challenge: 'Créer une application intuitive pour simplifier la gestion de tâches quotidiennes.',
        solution: '<p>Développement d\'une application native web avec une interface utilisateur soignée.</p>',
        link: 'https://www.edencorporate.com/'
      }
    }
  ];

  return (
    <main className="portfolio-page">
      {/* Hero Section */}
      <section className="portfolio-hero section-transition">
        <div className="portfolio-hero-bg" style={{ backgroundImage: `url(/IMG4.jpg)` }}></div>
        <div className="container">
          <div className="portfolio-hero-content">
            <h1 className="portfolio-hero-title">Nos Réalisations</h1>
            <div className="portfolio-breadcrumbs">
              <Link to="/">Accueil</Link>
              <span>/</span>
              <span>Réalisations</span>
            </div>
          </div>
        </div>
      </section>

      {/* Main Portfolio Section */}
      <section className="portfolio-main section-transition">
        <div className="portfolio-main-bg" style={{ backgroundImage: `url(/IMG3.jpg)` }}></div>
        <div className="container">
          <div className="portfolio-header">
            <p className="portfolio-section-subtitle">DÉCOUVREZ NOS PROJETS</p>
            <h2 className="portfolio-section-title">Découvrez la Qualité de Notre Travail</h2>
            <p className="portfolio-section-description">
              Explorez notre portfolio de projets réussis. Chaque réalisation témoigne de notre expertise 
              et de notre engagement envers l'excellence.
            </p>
          </div>

          <div className="portfolio-grid">
            {projects.map(project => (
              <div
                key={project.id}
                className="portfolio-item fade-in"
                onClick={() => setSelectedProject(project)}
              >
                <div className="portfolio-item-image">
                  <img src={project.image} alt={project.title} />
                  <div className="portfolio-item-overlay">
                    <button className="portfolio-item-button">
                      Voir les détails
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="portfolio-item-content">
                  <h3 className="portfolio-item-title">{project.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="contact-cta" className="section-transition">
        <div className="container">
          <div className="contact-cta-card">
            <div className="contact-cta-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                <path d="M2 17l10 5 10-5"></path>
                <path d="M2 12l10 5 10-5"></path>
              </svg>
            </div>
            <h2 className="contact-cta-title">Prêt à Transformer Votre Entreprise ?</h2>
            <p className="contact-cta-description">Rejoignez les entreprises leaders qui utilisent nos technologies de pointe pour se démarquer</p>
            <Link to="/contact" className="contact-cta-button">
              Contactez-nous
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </Link>
          </div>
        </div>
      </section>

      {selectedProject && (
        <PortfolioModal
          project={selectedProject.modalData}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </main>
  );
};

export default Portfolio;
